module.exports = __webpack_public_path__ + "assets/img/00.redis-hash.d7e2b43f.png";